import { path, pathOr } from 'ramda';

import {
	CREATE_OPPORTUNITY,
	CREATE_OPPORTUNITY_FAILED,
	CREATE_OPPORTUNITY_SUCCEEDED,
	FETCH_OPPORTUNITIES_SUCCEEDED,
	UPDATE_OPPORTUNITY,
	UPDATE_OPPORTUNITY_FAILED,
	UPDATE_OPPORTUNITY_SUCCEEDED,
} from './opportunity.action';
import { opportunitiesInitialState } from './opportunity.initialState';

export const opportunitiesReducer = (state = opportunitiesInitialState, action) => {
	switch (action.type) {
		case FETCH_OPPORTUNITIES_SUCCEEDED: {
			const data = pathOr([], ['payload', 'data'], action);
			const entities = data.reduce((accumulator, datum) => {
				accumulator[datum._id] = datum;
				return accumulator;
			}, {});

			return {
				...state,
				entities,
			};
		}

		case UPDATE_OPPORTUNITY:
			return {
				...state,
				pendingUpdate: true,
			};

		case UPDATE_OPPORTUNITY_SUCCEEDED:
			const updatedOpportunityId = path(['payload', '_id'], action);
			const newState = {
				...state,
				pendingUpdate: false,
			};

			if (updatedOpportunityId) {
				newState.entities = {
					...state.entities,
					[updatedOpportunityId]: action.payload,
				};
			}
			return newState;

		case UPDATE_OPPORTUNITY_FAILED:
			return {
				...state,
				pendingUpdate: false,
				updateError: action.payload,
			};

		case CREATE_OPPORTUNITY:
			return {
				...state,
				pendingCreate: true,
			};

		case CREATE_OPPORTUNITY_SUCCEEDED:
			return {
				...state,
				pendingCreate: false,
			};

		case CREATE_OPPORTUNITY_FAILED:
			return {
				...state,
				pendingCreate: false,
				createError: action.payload,
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/redux/opportunities/opportunity.reducer.js